export default "__VITE_ASSET__DtleEvQW__"